module.exports = __webpack_public_path__ + "img/13.83bb2cbd.png";